import { useTranslation } from "react-i18next";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import { NoResults } from "@/App/components";


const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementClaimDetailsForm";

interface NoResults {
  readonly isSingular: boolean;
}

export const DirectMemberReimbursementNoResults = ({
  isSingular = false,
}: NoResults) => {
  const { t: translate } = useTranslation();

  const count = isSingular ? 1 : 0;
  const message = translate(`${TRANSLATION_PATH}.no_result_found`, { count: count });

  return(
    <>
      <NoResults message={message} />
      <Stack spacing="none">
        <Shelf>
          <Body textAlign="center">
            {translate(`${TRANSLATION_PATH}.noResultsDetail`)}
          </Body>
        </Shelf>
      </Stack>
    </>
  );
};
